import { render, staticRenderFns } from "./customer-actions.vue?vue&type=template&id=5530bd59&"
import script from "./customer-actions.vue?vue&type=script&lang=js&"
export * from "./customer-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports